import React, { useMemo } from 'react';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import Sidebar from './Sidebar';
import useFetchDefaultInsightsDashboard from 'App/hooks/useFetchDefaultInsightsDashboard';
import InsightsIframe from './InsightsIframe';
import PageWithSidebar from 'App/components/PageWithSidebar';

const propTypes = {};

const defaultProps = {};

/**
 * Old version useed an eventListener in an attempt to reload the page data upon some "message" event.
 * This was only needed when a user first loads the page and accesses an embed link. Looker will create
 * the user only after this first embed access occurs, which means the sidebar wouldn't load until a
 * refresh.
 *
 * As of now, I am unable to accrurately determine if this is still the case or if this listener ever worked.
 * As such, I am leaving a note here for the future people to see if the problem occurs. For now, I'm going
 * to add a retry to the get user content hook in the sidebar.
 */

function TherigyInsights() {
    const { isLoading, data = {}, isError } = useFetchDefaultInsightsDashboard();

    const embedUrl = useMemo(() => {
        if (data.embedUrl) {
            return data.embedUrl;
        }
        return null;
    }, [data.embedUrl]);

    return (
        <PageWithSidebar
            title="TherigyInsights"
            showPageTitle={false}
            permissionType={PERMISSION_TYPES.THERIGY_INSIGHTS}
            sidebar={<Sidebar />}
            isLoading={isLoading}
            showNotFound={isError}
        >
            {!isLoading && !isError && embedUrl && <InsightsIframe key={embedUrl} embedUrl={embedUrl} />}
        </PageWithSidebar>
    );
}

TherigyInsights.propTypes = propTypes;
TherigyInsights.defaultProps = defaultProps;

export default TherigyInsights;
